module.exports = __webpack_public_path__ + "static/media/ports.24ca234b.svg";